import { useContext, useState,useEffect } from 'react'
import './App.css'
import Home from './components/Home'
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import AllPagiesLayout from './components/Layout/AllPagiesLayout'
import Podcast from './components/Podcast'
import { SideberContext } from './context/SidebarContext'
import Schedule from './components/Schedule'
import News from './components/News'
import Events from './components/Events'
import { NavbarContext } from './context/NavbarContext'
import PodcastAllOptions from './components/PodcastAllOptions'
import PodcastAllOptionsContextProvider, { PodcastAllOptionsContext } from './context/PodcastAllOptionsContext'
import PodcastAllOptionsInternal from './components/PodcastAllOptionsInternal'
import Blog from './components/Blog'
import EventsContextProvider from './context/EventsContext'
import EventsInner from './components/EventsInner'
import Albums from './components/Albums'
import Album from './components/Album'
import ApiContextProvider from './context/ApiContext'
import TvLayout from './components/Layout/TvLayout.jsx'
import Interviews from './components/Interviews.jsx'

function App() {
  const [mySidebar, setMySidebar] = useState(null)
  const [mySidebarSetting, setMySidebarSetting] = useState(null)
  const [myNotification, setMyNotification] = useState(null)
  const [ourService, setOurService] = useState(null)
  const [language, setLanguage] = useState(null)
  const [navHeading, setNavHeading] = useState(null)
  const navigate = useNavigate()

    useEffect(() => {
      if (window.performance) {
        if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
  // console.log("user reload the page");
  navigate("/")
  
        }
      }
    }, []);
  return (
    <>
      <ApiContextProvider>
        <NavbarContext.Provider value={{ navHeading, setNavHeading }}>
          <SideberContext.Provider value={{ mySidebar, setMySidebar ,mySidebarSetting, setMySidebarSetting,myNotification, setMyNotification,ourService, setOurService,language, setLanguage}}>
            <PodcastAllOptionsContextProvider>
              <EventsContextProvider>
              <Routes>
                <Route path='/' element={<AllPagiesLayout />}>
                  <Route index element={<Home />} />
                  <Route path='podcast' element={<Podcast />}/>
                  <Route path='Schedule' element={<Schedule />} />
                  <Route path='news' element={<News />} />
                  <Route path='events' element={<Events />}/>
                  <Route path='myevents' element={<EventsInner/>}/>
                  <Route path='podcast/:podcast' element={<PodcastAllOptions />}/>
                  <Route path='/player' element={<PodcastAllOptionsInternal/>}/>
                  {/* <Route path='/blog' element={<Blog/>}/> */}
                  <Route path='interviews' element={<Interviews/>}/>
                  <Route path='/albums' element={<Albums/>}/>
                  <Route path='/myalbum' element={<Album/>}/>
                </Route>
                  <Route path='/videoplayer' element={<TvLayout/>}/>
              </Routes>
              </EventsContextProvider>
              </PodcastAllOptionsContextProvider>
          </SideberContext.Provider>
        </NavbarContext.Provider>
        </ApiContextProvider>
    </>
  )
}

export default App
